<p-toast position="top-center" key="trust-number-check" />
<p-toast position="top-center" key="no-companies-created">
  <ng-template let-message #headless>
    @let icon =
      message.severity === 'error'
        ? 'phosphorXCircle'
        : message.severity === 'warn'
          ? 'phosphorWarning'
          : 'phosphorCheck';
    <div class="mx-3 my-2 flex items-center gap-3">
      <ng-icon [name]="icon" size="24px" />
      <div class="w-11/12 text-center text-sm font-normal">
        {{ message.summary }}
      </div>
    </div>
  </ng-template>
</p-toast>
<custom-toast />

<router-outlet></router-outlet>

<app-inactivity-warning />
